import { Component } from 'react';

export class CircleSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                data-testid="circle-svg"
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.28462 18.5692C14.4124 18.5692 18.5692 14.4124 18.5692 9.28462C18.5692 4.15686 14.4124 0 9.28462 0C4.15686 0 0 4.15686 0 9.28462C0 14.4124 4.15686 18.5692 9.28462 18.5692Z"
                    transform="translate(0 0.453125)"
                    fill="#DDDDDD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.4625 12.925C10.0316 12.925 12.925 10.0316 12.925 6.4625C12.925 2.89336 10.0316 0 6.4625 0C2.89336 0 0 2.89336 0 6.4625C0 10.0316 2.89336 12.925 6.4625 12.925Z"
                    transform="translate(2.82202 3.27539)"
                    fill="white"
                />
            </svg>
        );
    }
}
